module.exports = __webpack_public_path__ + "static/img/icon2.1f145587.png";